export const COOKIE_CONSENT = "cookie-consent";
export const CHAT_BOT = "chat-bot";
export const FEEDBACK_FORM = "feedback-enabled";
export const SWEDBANK_API = "swedbank-api";

export const USE_GOOGLE_AUTH = "use-google-auth";
export const USE_FACEBOOK_AUTH = "use-facebook-auth";

